module.exports = __webpack_public_path__ + "img/profess1.94e2a124.png";